import Axios from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";

interface TemplateResponse {
  backgroundTemplateUrl: string;
  meteoTemplateUrl: string;
  networkTemplateUrl: string;
  poiTemplateUrl: string;
  pointSourceTemplateUrl: string;
  tunnelTemplateUrl: string;
}

export function useTemplates() {
  async function queryFn(): Promise<TemplateResponse> {
    const url = "/planning-api/templates";
    const result = await Axios.get(url);
    return result.data;
  }
  return useQuery(baseDataKeys.templates, queryFn);
}
